var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-triangle_svg__clip0_6782_95319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.813 31.25h-5.646V14.583h5.645V31.25zm-5.646 4.167h5.645v5.666h-5.645v-5.666zm26.666 4.166L29 6.625s-4.167-6.813-8.125 0L1.063 39.583s-4.167 6.792 3.833 6.792H45.02s7.896 0 3.812-6.792",
    fill: "#DB6E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-triangle_svg__clip0_6782_95319"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v50H0z"
  })))));
}
export default SvgWarningTriangle;